import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CampaignIcon from "@mui/icons-material/Campaign";
import SettingsIcon from "@mui/icons-material/Settings";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { MenuList } from "../enums/menu-lis";

export interface MenuItemConfig {
  key: MenuList;
  label: string;
  icon: React.ReactNode;
  path: string;
}

export const menuItems: MenuItemConfig[] = [
  {
    key: MenuList.DASHBOARD,
    label: "Tableau de bord",
    icon: <DashboardIcon />,
    path: `/${MenuList.DASHBOARD}`,
  },
  {
    key: MenuList.HOSTERS,
    label: "Annonceurs",
    icon: <PersonOutlineIcon />,
    path: `/${MenuList.HOSTERS}`,
  },
  {
    key: MenuList.USERS,
    label: "Utilisateurs",
    icon: <PeopleIcon />,
    path: `/${MenuList.USERS}`,
  },
  {
    key: MenuList.HOSTINGS,
    label: "Annonces",
    icon: <CampaignIcon />,
    path: `/${MenuList.HOSTINGS}`,
  },
  {
    key: MenuList.SETTINGS,
    label: "Paramètres",
    icon: <SettingsIcon />,
    path: `/${MenuList.SETTINGS}`,
  },
  {
    key: MenuList.SUPPORT,
    label: "Support",
    icon: <HelpOutlineIcon />,
    path: `/${MenuList.SUPPORT}`,
  },
];
